<div class="flex flex-wrap mt-4">

    <div class="my-4 w-full">
        <div class="flex justify-end">

            <!-- <button (click)="refreshChannel()"
                class="bg-primary-500 active:bg-secondary-500 hover:bg-primary-300 uppercase text-white font-bold hover:shadow-lg shadow text-sm px-4 py-4 rounded outline-none focus:outline-none mr-2 mb-1 ease-linear transition-all duration-150"
                type="button"><i class="fa fa-refresh mr-2 leading-relaxed"></i>Refresh
            </button> -->
            <button [routerLink]="['create']"
                class="bg-secondary-500 active:bg-primary-500 hover:bg-primary-300 text-white hover:shadow-lg shadow text-xs font-bold uppercase px-4 py-2 rounded outline-none focus:outline-none mb-1 ease-linear transition-all duration-150"
                type="button"><i class="fa fa-add mr-2 leading-relaxed"></i>Add New
            </button>

            <!-- <button (click)="deleteChannel()"
                class="bg-red-500 active:bg-secondary-500 hover:bg-secondary-500 uppercase text-white font-bold hover:shadow-lg shadow text-sm px-4 py-3 rounded outline-none focus:outline-none mb-1 ease-linear transition-all duration-150"
                type="button"><i class="fa fa-trash-alt mr-2 leading-relaxed"></i>Delete
            </button> -->
        </div>
    </div>

    <div class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded bg-white">
        <div class="rounded-t mb-0 px-4 py-3 border-0">
            <div class="flex flex-wrap items-center">
                <div class="relative w-full px-2 max-w-full flex-grow flex-1">
                    <h3 class="font-semibold text-lg text-blueGray-700">
                        My Articles
                    </h3>
                </div>
            </div>
        </div>


        <div class="block w-full overflow-x-auto">
            <table class="items-center w-full bg-transparent text-sm border-collapse">
                <thead>
                    <tr>
                        <th
                            class="px-6 align-middle border-0 border-solid py-3 uppercase whitespace-nowrap font-semibold text-left bg-blueGray-50 text-blueGray-500 border-blueGray-100">
                            Title
                        </th>
                        <!-- <th
              class="px-6 align-middle border border-solid py-3 uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left bg-blueGray-50 text-blueGray-500 border-blueGray-100">
              Created Date
            </th> -->
                        <th
                            class="px-6 align-middle border-0 border-solid py-3 uppercase whitespace-nowrap font-semibold text-left bg-blueGray-50 text-blueGray-500 border-blueGray-100">
                            Modified Date
                        </th>
                        <th
                            class="px-6 align-middle border-0 border-solid py-3 uppercase whitespace-nowrap font-semibold text-left bg-blueGray-50 text-blueGray-500 border-blueGray-100">
                            Publish Status
                        </th>
                        <th class=" px-6 align-middle border-0 border-solid py-3 uppercase border-l-0 border-r-0
              whitespace-nowrap font-semibold text-left bg-blueGray-50 text-blueGray-500 border-blueGray-100">
                            Language
                        </th>
                        <th
                            class="px-6 align-middle border-0 border-solid py-3 uppercase whitespace-nowrap font-semibold text-left bg-blueGray-50 text-blueGray-500 border-blueGray-100">
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngIf="loading">
                        <td class="px-6">
                            <div class="h-4 w-full pr-8 rounded my-4">
                                <ngx-skeleton-loader count="1" appearance="line" />
                            </div>
                        </td>
                        <td class="px-6">
                            <div class="h-4 w-full pr-8 rounded my-4">
                                <ngx-skeleton-loader count="1" appearance="line" />
                            </div>
                        </td>
                        <td class="px-6">
                            <div class="h-4 w-full pr-8 rounded my-4">
                                <ngx-skeleton-loader count="1" appearance="line" />
                            </div>
                        </td>
                        <td class="px-6">
                            <div class="h-4 w-full pr-8 rounded my-4">
                                <ngx-skeleton-loader count="1" appearance="line" />
                            </div>
                        </td>
                    </tr>
                    <tr *ngFor="let item of articles$ | async">
                        <!-- <td mat-cell *matCellDef="let row">
                            <mat-checkbox (click)="$event.stopPropagation()"
                                (change)="$event ? selection.toggle(row) : null"
                                [checked]="selection.isSelected(row)">
                            </mat-checkbox>
                          </td> -->
                        <td
                            class="border-t-0 px-6 align-middle border-l-0 border-r-0 whitespace-nowrap p-4 text-left flex items-center">
                            <a [routerLink]="[item.id]">
                                <div class="flex items-center">
                                    <div class="inline-block flex-none">
                                        <img *ngIf="item.imageUrl" [src]="item.imageUrl"
                                            class="min-h-12 max-h-12 max-w-12 min-w-12 bg-white rounded-full border-none" />
                                        <div *ngIf="!item.imageUrl"
                                            class="bg-primary-100 uppercase text-primary-500 text-base flex justify-center items-center text-center h-12 w-12 rounded-full">
                                            {{item.title | initials}}
                                        </div>
                                    </div>
                                    <div class="flex-1 inline-flex flex-span ml-3 text-sm font-bold text-blueGray-600">
                                        <span>{{item.title}}</span>
                                    </div>
                                </div>
                            </a>
                        </td>
                        <td class="border-t-0 px-6 align-middle text-sm border-l-0 border-r-0 whitespace-nowrap p-4">
                            {{item.modified! | moment: 'Do MMM YYYY hh:mm a'}}
                        </td>
                        <td class="border-t-0 px-6 align-middle text-sm border-l-0 border-r-0 whitespace-nowrap">
                            <span data-dismissible="chip"
                                class="relative select-none center whitespace-nowrap w-auto rounded-lg {{item.publishStatus === 'published' ? 'bg-green-50 text-green-700' : item.publishStatus == 'review' ? 'bg-primary-500 text-white' : 'bg-primary-100 text-primary-500'}} py-1.5 px-3 text-xs font-semibold ">
                                {{item.publishStatus}}
                            </span>
                        </td>
                        <td class="border-t-0 px-6 align-middle text-sm border-l-0 border-r-0 whitespace-nowrap p-4">
                            {{item.lang}}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>